/**
 * pw-gallery カラーフィルター
 *
 * 商品バリアント（カラー）が切り替わったとき、pw-gallery の画像を
 * ALT テキストの "COLOR: <value>" フォーマットに基づいてフィルタリングする。
 *
 * 依存: pubsub.js, constants.js (どちらも theme.liquid で defer 読み込み済み)
 *
 * ALT テキストのフォーマット例:
 *   "COLOR: CHARCOAL"  → カラー値 = "CHARCOAL"
 *   "COLOR: BLACK"     → カラー値 = "BLACK"
 *   ALT なし / COLOR: なし → 常に表示
 */

/**
 * 指定ギャラリーの slides をカラー値でフィルタリングする。
 * @param {HTMLElement} gallery - [data-pw-gallery] 要素
 * @param {string} colorValue   - 大文字のカラー値 (例: "CHARCOAL")
 */
function filterGalleryByColor(gallery, colorValue) {
  const slides = gallery.querySelectorAll('.pw-gallery__slide[data-alt]');
  if (!slides.length) return;

  // COLOR: タグを持つスライドを抽出
  const colorTaggedSlides = Array.from(slides).filter((s) =>
    s.dataset.alt.includes('COLOR:')
  );

  // カラータグなし、またはカラー値が空 → 全スライド表示
  if (!colorTaggedSlides.length || !colorValue) {
    slides.forEach((s) => (s.hidden = false));
    return;
  }

  // フィルタリング実行
  let matchCount = 0;
  colorTaggedSlides.forEach((slide) => {
    const matches = slide.dataset.alt.includes(colorValue);
    slide.hidden = !matches;
    if (matches) matchCount++;
  });

  // フォールバック: マッチ0件なら全スライド表示
  if (matchCount === 0) {
    slides.forEach((s) => (s.hidden = false));
  }
}

/**
 * variantChange イベントを購読し、ギャラリーをフィルタリングする。
 * constants.js / pubsub.js が defer で遅延読み込みされるため、
 * DOMContentLoaded 後に subscribe を呼び出す。
 */
document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
    document.querySelectorAll('[data-pw-gallery][data-color-option-index]').forEach((gallery) => {
      const colorOptionIndex = parseInt(gallery.dataset.colorOptionIndex, 10);
      if (isNaN(colorOptionIndex)) return;

      // variant.option1 / option2 / option3 からカラー値を取得
      const optionKey = `option${colorOptionIndex + 1}`;
      const colorValue = (variant?.[optionKey] ?? '').toUpperCase().trim();

      filterGalleryByColor(gallery, colorValue);
    });
  });
});
